function init_news(group_id = null) {
    let news = new News();
    let btn = $('#show-more-news');

    let url = '/news/ajax-get-news-cart';
    let ajaxCallback = (response) => {
        if (response.count <= 6) {
            btn.hide();
        }

        console.log(response.count);

        let offset = news.getOffset();
        news.setOffset(offset + 6);
    };

    console.log(news.getOffset());

    btn.on('click', function () {
        let request = new AjaxParts('.ajax--news-cart', {
            url: url,
            data: {
                'offset': news.getOffset(),
                'group_id': group_id
            },
            callback: ajaxCallback
        })
        request.ajaxRequest();
    });
}

class News {
    _offset = 6;

    setOffset(offset) {
        this._offset = offset;
    }

    getOffset() {
        return this._offset;
    }
}